function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import { BUYER_AUDIENCE_ALL, NOTE_TAPE_PERFORMANCE_PERFORMING } from '@paperstac/constants';
import { centsToUsdString } from '@paperstac/helpers/lib/numberHelpers';
import { camelToTitle, toTitle } from '@paperstac/helpers/lib/stringHelpers';
import format from 'date-fns/format';
import uniqBy from 'lodash/uniqBy';
import * as Yup from 'yup';
import { getReasonsForUnlistable as getNoteReasons } from './notesHelper';
import { getNameFromCode } from './states';
export var listingPropertyLabelsMap = {
  negotiationType: 'Negotiation Type'
};
export var getReasonsForUnlistable = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(listing) {
    var schema, _yield$Promise$all, _yield$Promise$all2, listingReasons, noteReasons;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            schema = Yup.object().shape({
              negotiationType: Yup.string().required("".concat(listingPropertyLabelsMap['negotiationType'], " is required"))
            });
            _context2.next = 3;
            return Promise.all([schema.validate(listing, {
              abortEarly: false
            }).then(function () {
              return [];
            })["catch"](function (_ref2) {
              var errors = _ref2.errors;
              return errors;
            }), listing.notes.reduce( /*#__PURE__*/function () {
              var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(promise, note) {
                var noteReasonsMap;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return promise;
                      case 2:
                        noteReasonsMap = _context.sent;
                        _context.next = 5;
                        return getNoteReasons(note);
                      case 5:
                        noteReasonsMap[note.id] = _context.sent;
                        return _context.abrupt("return", noteReasonsMap);
                      case 7:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));
              return function (_x2, _x3) {
                return _ref3.apply(this, arguments);
              };
            }(), Promise.resolve({}))]);
          case 3:
            _yield$Promise$all = _context2.sent;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
            listingReasons = _yield$Promise$all2[0];
            noteReasons = _yield$Promise$all2[1];
            if (listing.isPool && listing.notes.length < 2) {
              listingReasons.push('Pool listings require at least 2 notes');
            }
            return _context2.abrupt("return", {
              count: Object.values(noteReasons).reduce(function (count, nr) {
                return count + (Array.isArray(nr) ? nr.length : 0);
              }, listingReasons.length),
              listing: listingReasons,
              notes: noteReasons
            });
          case 9:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function getReasonsForUnlistable(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var listingLabel = function listingLabel(property) {
  if (!listingData[property]) {
    return camelToTitle(property);
  }
  return listingData[property].label || camelToTitle(property);
};
export var listingCellLabel = function listingCellLabel(property) {
  if (!listingData[property]) {
    return listingLabel(property);
  }
  return listingData[property].cellLabel || listingLabel(property);
};
export var listingValueFormatted = function listingValueFormatted(property, row) {
  return listingData[property].valueFormatter ? listingData[property].valueFormatter(row) : row[property];
};
export var arrayToStringFormatter = function arrayToStringFormatter(arr) {
  var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;
  if (!Array.isArray(arr)) {
    return arr;
  }
  var unique = uniqBy(arr);
  if (unique.length > max) {
    return "Multiple (".concat(unique.length, ")");
  }
  return unique.join(', ');
};
export var statesValueFormatter = function statesValueFormatter(states) {
  var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;
  if (!Array.isArray(states)) {
    return getNameFromCode(states);
  }
  var unique = uniqBy(states);
  if (unique.length === 1) {
    return getNameFromCode(unique[0]);
  }
  if (unique.length > max) {
    return "Multiple (".concat(unique.length, ")");
  }
  return unique.join(', ');
};
export var performanceValueFormatter = function performanceValueFormatter(arr) {
  if (!Array.isArray(arr)) {
    return arr;
  }
  var unique = uniqBy(arr);
  if (unique.length === 1) {
    return arr[0];
  }
  return 'Mixed (PL & NPL)';
};
export var listingCellValueFormatted = function listingCellValueFormatted(property, value) {
  try {
    return listingData[property].cellValueFormatter ? listingData[property].cellValueFormatter(value) : listingValueFormatted(property, value);
  } catch (e) {
    return null;
  }
};
export var buildManageListingsColumnSettings = function buildManageListingsColumnSettings() {
  var customSettings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return Object.keys(listingData).filter(function (prop) {
    return !!listingData[prop].manageListingsSpreadsheet;
  }).reduce(function (settings, prop) {
    if (!listingData[prop]) {
      return settings;
    }
    var defaultPropSettings = {
      order: listingData[prop].manageListingsSpreadsheet.order,
      pinned: listingData[prop].manageListingsSpreadsheet.pinned,
      enabled: listingData[prop].manageListingsSpreadsheet.enabled
    };
    settings[prop] = customSettings[prop] ? _objectSpread(_objectSpread({}, defaultPropSettings), customSettings[prop]) : defaultPropSettings;
    return settings;
  }, {
    url: {
      label: 'URL',
      order: 1,
      enabled: true,
      pinned: true
    }
  });
};
export var buildViewListingsColumnSettings = function buildViewListingsColumnSettings() {
  var customSettings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return Object.keys(listingData).filter(function (prop) {
    return !!listingData[prop].viewListingsSpreadsheet;
  }).reduce(function (settings, prop) {
    if (!listingData[prop]) {
      return settings;
    }
    var defaultPropSettings = {
      order: listingData[prop].viewListingsSpreadsheet.order,
      pinned: listingData[prop].viewListingsSpreadsheet.pinned,
      enabled: listingData[prop].viewListingsSpreadsheet.enabled
    };
    settings[prop] = customSettings[prop] ? _objectSpread(_objectSpread({}, defaultPropSettings), customSettings[prop]) : defaultPropSettings;
    return settings;
  }, {});
};
export var getColumnsFromSettings = function getColumnsFromSettings(columnSettings) {
  return Object.keys(columnSettings).filter(function (prop) {
    return columnSettings[prop].enabled;
  }).sort(function (propOne, propTwo) {
    if (columnSettings[propOne].pinned && !columnSettings[propTwo].pinned) {
      return -1;
    }
    if (!columnSettings[propOne].pinned && columnSettings[propTwo].pinned) {
      return 1;
    }
    return columnSettings[propOne].order < columnSettings[propTwo].order ? -1 : 1;
  });
};
export var getPinnedColumnsCount = function getPinnedColumnsCount(columnSettings) {
  return Object.keys(columnSettings).filter(function (prop) {
    return columnSettings[prop].pinned && columnSettings[prop].enabled;
  }).length;
};
var dateFormatter = function dateFormatter(value) {
  return value ? format(new Date(value), 'MMM d, yyyy') : '';
};
var percentFormatter = function percentFormatter(value) {
  return !isNaN(value) ? "".concat(value, "%") : '';
};
var arrayFormatter = function arrayFormatter(dataArray, formatterFunc) {
  return dataArray.length === 1 ? formatterFunc(dataArray[0]) : dataArray.map(function (v) {
    return formatterFunc(v);
  });
};
var booleanFormatter = function booleanFormatter(value) {
  if (Array.isArray(value)) {
    return arrayFormatter(value, booleanFormatter);
  }
  return typeof value === 'boolean' ? value ? 'Yes' : 'No' : '';
};
export var getCellWidth = function getCellWidth(property) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 120;
  if (property === 'checkbox') {
    return 40;
  }
  if (!listingData[property]) {
    return defaultValue;
  }
  return listingData[property].cellWidth ? listingData[property].cellWidth : defaultValue;
};
var listingData = {
  accountId: {},
  'noteMetaAgg.accruedLateCharges': {
    cellLabel: 'Late Chrgs',
    valueFormatter: function valueFormatter(row) {
      return centsToUsdString(row.noteMetaAgg.accruedLateCharges);
    },
    manageListingsSpreadsheet: {
      order: 18,
      enabled: true,
      pinned: false
    },
    viewListingsSpreadsheet: {
      order: 18,
      enabled: true,
      pinned: false
    }
  },
  buyerAudience: {
    cellWidth: 170,
    cellLabel: 'Audience',
    valueFormatter: function valueFormatter(row) {
      switch (row.buyerAudience) {
        case BUYER_AUDIENCE_ALL:
          return 'All Paperstac Buyers';
        default:
          return 'Unknown';
      }
    },
    manageListingsSpreadsheet: {
      order: 13,
      enabled: true,
      pinned: false
    }
  },
  bathrooms: {},
  bedrooms: {},
  borrowerName: {},
  checkbox: {},
  city: {},
  cityStateZip: {},
  country: {},
  county: {},
  createdDate: {},
  "delete": {
    cellWidth: 100,
    manageListingsSpreadsheet: {
      order: 35,
      enabled: true,
      pinned: false
    }
  },
  'noteMetaAgg.escrowImpounds': {
    label: 'Escrow/Impounds',
    cellLabel: 'Escrw/Impnds',
    valueFormatter: function valueFormatter(row) {
      return centsToUsdString(row.noteMetaAgg.escrowImpounds);
    },
    manageListingsSpreadsheet: {
      order: 31,
      enabled: true,
      pinned: false
    },
    viewListingsSpreadsheet: {
      order: 31,
      enabled: true,
      pinned: false
    }
  },
  filesCount: {},
  floorSizeSqFt: {},
  fullAddress: {},
  hasListing: {},
  hasPoolListing: {},
  history: {},
  id: {},
  'noteMetaAgg.interestRatePercent': {
    label: 'Interest Rate',
    cellLabel: 'Int Rate',
    valueFormatter: function valueFormatter(row) {
      return percentFormatter(row.noteMetaAgg.interestRatePercent);
    },
    cellWidth: 95,
    manageListingsSpreadsheet: {
      order: 15,
      enabled: true,
      pinned: false
    },
    viewListingsSpreadsheet: {
      order: 15,
      enabled: true,
      pinned: false
    }
  },
  'investmentMetaAgg.investmentToBalancePercent': {
    label: 'Investment to Balance',
    cellLabel: 'ITB',
    valueFormatter: function valueFormatter(row) {
      return percentFormatter(row.investmentMetaAgg.investmentToBalancePercent);
    },
    cellWidth: 60,
    manageListingsSpreadsheet: {
      order: 6,
      enabled: true,
      pinned: false
    },
    viewListingsSpreadsheet: {
      order: 6,
      enabled: true,
      pinned: false
    }
  },
  'investmentMetaAgg.investmentToValuePercent': {
    label: 'Investment to Value',
    cellLabel: 'ITV',
    valueFormatter: function valueFormatter(row) {
      return percentFormatter(row.investmentMetaAgg.investmentToValuePercent);
    },
    cellWidth: 60,
    manageListingsSpreadsheet: {
      order: 7,
      enabled: true,
      pinned: false
    },
    viewListingsSpreadsheet: {
      order: 7,
      enabled: true,
      pinned: false
    }
  },
  isActive: {
    label: 'Active',
    cellLabel: 'Active',
    cellWidth: 80,
    manageListingsSpreadsheet: {
      order: 3,
      enabled: true,
      pinned: true
    }
  },
  'noteMetaAgg.isHardestHitFundState': {
    label: 'Hardest Hit Fund State',
    cellLabel: 'Hard Hit St',
    valueFormatter: function valueFormatter(row) {
      return booleanFormatter(row.noteMetaAgg.isHardestHitFundState);
    },
    manageListingsSpreadsheet: {
      order: 24,
      enabled: true,
      pinned: false
    },
    viewListingsSpreadsheet: {
      order: 24,
      enabled: true,
      pinned: false
    }
  },
  'noteMetaAgg.isJudicialState': {
    label: 'Judicial State',
    cellLabel: 'Judicial St',
    valueFormatter: function valueFormatter(row) {
      return booleanFormatter(row.noteMetaAgg.isJudicialState);
    },
    cellWidth: 115,
    manageListingsSpreadsheet: {
      order: 25,
      enabled: true,
      pinned: false
    },
    viewListingsSpreadsheet: {
      order: 25,
      enabled: true,
      pinned: false
    }
  },
  'noteMetaAgg.isNonJudicialState': {
    isNonJudicialState: 'Non-Judicial State',
    cellLabel: 'Non-Jdcl St',
    valueFormatter: function valueFormatter(row) {
      return booleanFormatter(row.noteMetaAgg.isJudicialState);
    },
    cellWidth: 125,
    order: 26,
    spreadsheetViewEnabled: true,
    spreadsheetViewPinned: false,
    manageListingsSpreadsheet: {
      order: 26,
      enabled: true,
      pinned: false
    },
    viewListingsSpreadsheet: {
      order: 26,
      enabled: true,
      pinned: false
    }
  },
  'noteMetaAgg.lastImportDate': {
    valueFormatter: function valueFormatter(row) {
      return dateFormatter(row.noteMetaAgg.lastImportDate);
    },
    cellLabel: 'Imported',
    manageListingsSpreadsheet: {
      order: 33,
      enabled: true,
      pinned: false
    },
    viewListingsSpreadsheet: {
      order: 33,
      enabled: true,
      pinned: false
    }
  },
  lastPaymentReceivedDate: {},
  lat: {},
  'noteMetaAgg.legalStatus': {
    label: 'Legal Status',
    cellWidth: 125,
    valueFormatter: function valueFormatter(row) {
      return row.noteMetaAgg.legalStatus.length === 1 ? row.noteMetaAgg.legalStatus[0] : row.noteMetaAgg.legalStatus;
    },
    manageListingsSpreadsheet: {
      order: 12,
      enabled: true,
      pinned: false
    },
    viewListingsSpreadsheet: {
      order: 12,
      enabled: true,
      pinned: false
    }
  },
  'noteMetaAgg.lienPosition': {
    label: 'Lien Position',
    cellLabel: 'Lien Pos',
    cellWidth: 100,
    valueFormatter: function valueFormatter(row) {
      return row.noteMetaAgg.lienPosition.length === 1 ? row.noteMetaAgg.lienPosition[0] : row.noteMetaAgg.lienPosition;
    },
    manageListingsSpreadsheet: {
      order: 14,
      enabled: true,
      pinned: false
    },
    viewListingsSpreadsheet: {
      order: 14,
      enabled: true,
      pinned: false
    }
  },
  listingType: {
    valueFormatter: function valueFormatter(row) {
      return row.isPool ? 'Pool' : 'Single Asset';
    },
    cellWidth: 40,
    manageListingsSpreadsheet: {
      order: 1,
      enabled: true,
      pinned: true
    },
    viewListingsSpreadsheet: {
      order: 1,
      enabled: true,
      pinned: true
    }
  },
  listPrice: {
    cellLabel: 'Price',
    cellWidth: 130,
    valueFormatter: function valueFormatter(row) {
      return centsToUsdString(row.listPrice);
    },
    manageListingsSpreadsheet: {
      order: 5,
      enabled: true,
      pinned: false
    },
    viewListingsSpreadsheet: {
      order: 5,
      enabled: true,
      pinned: false
    }
  },
  listedDate: {
    label: 'Date Listed',
    cellLabel: 'Listed',
    valueFormatter: function valueFormatter(row) {
      return dateFormatter(row.listedDate);
    },
    manageListingsSpreadsheet: {
      order: 34,
      enabled: true,
      pinned: false
    },
    viewListingsSpreadsheet: {
      order: 34,
      enabled: true,
      pinned: false
    }
  },
  lng: {},
  loanId: {},
  'noteMetaAgg.loanToValuePercent': {
    label: 'Loan to Value',
    cellLabel: 'LTV',
    cellWidth: 70,
    valueFormatter: function valueFormatter(row) {
      return percentFormatter(row.noteMetaAgg.loanToValuePercent);
    },
    manageListingsSpreadsheet: {
      order: 20,
      enabled: true,
      pinned: false
    },
    viewListingsSpreadsheet: {
      order: 20,
      enabled: true,
      pinned: false
    }
  },
  lotSizeSqFt: {},
  maturityDate: {},
  nextPaymentDate: {},
  noteCount: {
    label: 'Note Count',
    cellLabel: 'Notes',
    cellWidth: 80,
    manageListingsSpreadsheet: {
      order: 9,
      enabled: true,
      pinned: false
    }
  },
  'noteMetaAgg.noteType': {
    label: 'Note Type',
    cellLabel: 'Note Type',
    valueFormatter: function valueFormatter(row) {
      return row.noteMetaAgg.noteType.length === 1 ? row.noteMetaAgg.noteType[0] : row.noteMetaAgg.noteType;
    },
    cellWidth: 120,
    manageListingsSpreadsheet: {
      order: 13.5,
      enabled: true,
      pinned: false
    },
    viewListingsSpreadsheet: {
      order: 13.5,
      enabled: true,
      pinned: false
    }
  },
  occupancyStatus: {},
  'noteMetaAgg.originalBalance': {
    cellLabel: 'Orig Bal',
    valueFormatter: function valueFormatter(row) {
      return centsToUsdString(row.noteMetaAgg.originalBalance);
    },
    manageListingsSpreadsheet: {
      order: 17,
      enabled: true,
      pinned: false
    },
    viewListingsSpreadsheet: {
      order: 17,
      enabled: true,
      pinned: false
    }
  },
  originationDate: {},
  'noteMetaAgg.paymentsRemaining': {
    cellLabel: 'Pmt Remain',
    valueFormatter: function valueFormatter(row) {
      return row.noteMetaAgg.paymentsRemaining;
    },
    manageListingsSpreadsheet: {
      order: 30,
      enabled: true,
      pinned: false
    },
    viewListingsSpreadsheet: {
      order: 30,
      enabled: true,
      pinned: false
    }
  },
  'noteMetaAgg.performance': {
    label: 'Performance (PL/NPL)',
    cellLabel: 'PL/NPL',
    cellWidth: 90,
    valueFormatter: function valueFormatter(row) {
      return arrayFormatter(row.noteMetaAgg.performance, function (value) {
        return value === NOTE_TAPE_PERFORMANCE_PERFORMING ? 'Performing' : 'Non-Performing';
      });
    },
    cellValueFormatter: function cellValueFormatter(row) {
      return arrayFormatter(row.noteMetaAgg.performance, function (value) {
        return value === NOTE_TAPE_PERFORMANCE_PERFORMING ? 'PL' : 'NPL';
      });
    },
    manageListingsSpreadsheet: {
      order: 8,
      enabled: true,
      pinned: false
    },
    viewListingsSpreadsheet: {
      order: 8,
      enabled: true,
      pinned: false
    }
  },
  photoUrl: {
    cellLabel: 'Photo',
    cellWidth: 40,
    manageListingsSpreadsheet: {
      order: 2,
      enabled: true,
      pinned: true
    },
    viewListingsSpreadsheet: {
      order: 2,
      enabled: true,
      pinned: true
    }
  },
  photosCount: {},
  'noteMetaAgg.principalAndInterestPayment': {
    requiredToImport: true,
    importedFromTape: true,
    valueFormatter: function valueFormatter(row) {
      return centsToUsdString(row.noteMetaAgg.principalAndInterestPayment);
    },
    cellLabel: 'P&I Pmt',
    cellWidth: 100,
    manageListingsSpreadsheet: {
      order: 28,
      enabled: true,
      pinned: false
    },
    viewListingsSpreadsheet: {
      order: 28,
      enabled: true,
      pinned: false
    }
  },
  propertyType: {},
  'noteMetaAgg.propertyValue': {
    label: 'Property Value',
    cellLabel: 'Prop Val',
    valueFormatter: function valueFormatter(row) {
      return row.noteMetaAgg.propertyValue ? centsToUsdString(row.noteMetaAgg.propertyValue) : '';
    },
    manageListingsSpreadsheet: {
      order: 19,
      enabled: true,
      pinned: false
    },
    viewListingsSpreadsheet: {
      order: 15,
      enabled: true,
      pinned: false
    }
  },
  'noteMetaAgg.rentZestimate': {
    cellLabel: 'Rent Zest',
    valueFormatter: function valueFormatter(row) {
      return centsToUsdString(row.noteMetaAgg.rentZestimate);
    },
    manageListingsSpreadsheet: {
      order: 22,
      enabled: true,
      pinned: false
    }
  },
  sellerComments: {
    cellWidth: 300,
    manageListingsSpreadsheet: {
      order: 11,
      enabled: true,
      pinned: false
    },
    viewListingsSpreadsheet: {
      order: 11,
      enabled: true,
      pinned: false
    }
  },
  servicer: {},
  'noteMetaAgg.state': {
    label: 'State',
    cellLabel: 'St',
    cellWidth: 60,
    valueFormatter: function valueFormatter(row) {
      return arrayFormatter(row.noteMetaAgg.state, function (val) {
        return val;
      });
    },
    manageListingsSpreadsheet: {
      order: 23,
      enabled: true,
      pinned: false
    },
    viewListingsSpreadsheet: {
      order: 23,
      enabled: true,
      pinned: false
    }
  },
  starredListing: {
    valueFormatter: function valueFormatter(row) {
      return 'Starred Listing';
    },
    cellWidth: 40,
    viewListingsSpreadsheet: {
      order: 0,
      enabled: true,
      pinned: true
    }
  },
  streetAddress: {
    cellValueFormatter: function cellValueFormatter(row) {
      return arrayFormatter(row.notes.map(function (note) {
        return note.streetAddress;
      }), toTitle);
    },
    cellWidth: 180,
    manageListingsSpreadsheet: {
      order: 10,
      enabled: true,
      pinned: false
    }
  },
  streetAddress1: {},
  streetAddress2: {},
  title: {
    cellWidth: 230,
    manageListingsSpreadsheet: {
      order: 4,
      enabled: true,
      pinned: false
    },
    viewListingsSpreadsheet: {
      order: 4,
      enabled: true,
      pinned: false
    }
  },
  'noteMetaAgg.totalMonthlyLoanPayment': {
    cellLabel: 'Monthly Pmt',
    valueFormatter: function valueFormatter(row) {
      return centsToUsdString(row.noteMetaAgg.totalMonthlyLoanPayment);
    },
    cellWidth: 130,
    manageListingsSpreadsheet: {
      order: 29,
      enabled: true,
      pinned: false
    },
    viewListingsSpreadsheet: {
      order: 29,
      enabled: true,
      pinned: false
    }
  },
  'noteMetaAgg.totalPayoff': {
    label: 'Total Payoff',
    valueFormatter: function valueFormatter(row) {
      return centsToUsdString(row.noteMetaAgg.totalPayoff);
    },
    cellWidth: 125,
    manageListingsSpreadsheet: {
      order: 27,
      enabled: true,
      pinned: false
    },
    viewListingsSpreadsheet: {
      order: 27,
      enabled: true,
      pinned: false
    }
  },
  'noteMetaAgg.upb': {
    label: 'Principal Balance',
    cellLabel: 'Principal',
    valueFormatter: function valueFormatter(row) {
      return centsToUsdString(row.noteMetaAgg.upb);
    },
    manageListingsSpreadsheet: {
      order: 16,
      enabled: true,
      pinned: false
    },
    viewListingsSpreadsheet: {
      order: 16,
      enabled: true,
      pinned: false
    }
  },
  'noteMetaAgg.trustedSource': {
    label: 'Trusted Source',
    valueFormatter: booleanFormatter,
    manageListingsSpreadsheet: {
      order: 32,
      enabled: true,
      pinned: false
    },
    viewListingsSpreadsheet: {
      order: 32,
      enabled: true,
      pinned: false
    }
  },
  yearBuilt: {},
  'noteMetaAgg.zestimate': {
    label: 'Zestimate',
    valueFormatter: function valueFormatter(row) {
      return centsToUsdString(row.noteMetaAgg.zestimate);
    },
    manageListingsSpreadsheet: {
      order: 21,
      enabled: true,
      pinned: false
    }
  },
  zip: {}
};